import { Loader2Icon } from 'lucide-react'
import type { MoodboardStatus } from '@backend/lib/db/schema/moodboard'
import { Badge } from '@/components/ui/shadcn/badge'

// Single source of truth for how a moodboard's brief lifecycle reads in the UI
// (list page, home picker). `analyzing` is the state a board sits in while its
// brief generates in the background during onboarding.
export function MoodboardStatusBadge({ status }: { status: MoodboardStatus }) {
  switch (status) {
    case 'ready':
      return (
        <Badge variant="secondary" className="text-xs">
          Ready
        </Badge>
      )
    case 'analyzing':
      return (
        <Badge variant="outline" className="gap-1 text-xs">
          <Loader2Icon size={11} className="animate-spin" />
          Analyzing…
        </Badge>
      )
    case 'failed':
      return (
        <Badge variant="destructive" className="text-xs">
          Failed
        </Badge>
      )
    case 'draft':
    default:
      return (
        <Badge variant="outline" className="text-xs">
          Not analyzed
        </Badge>
      )
  }
}
